import React, { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

import Footer from './components/Footer';
import Navbar from './components/NavBar';
import LoginForm from './components/LoginForm';
import SolarSystem from './components/SolarSystem';
import XploreLanding from './components/LandingPage';
import NASASpaceApp from './components/NASASpaceAppChallenge/nasaspaceapp';
import SARObservatory from './components/sar_observatory/SARObservatory';


import Dashboard from './components/Dashboard';
import Intro from './components/Intro';

import './App.css';

function App() {
  // const location = useLocation();
  // const { isLoggedIn, setIsLoggedIn } = useAuth();

  // const [isDarkMode, setIsDarkMode] = useState(false);
  // const [showIntro, setShowIntro] = useState(true);

  // useEffect(() => {
  //   const darkModePreference = localStorage.getItem('darkMode');
  //   if (darkModePreference === 'true') {
  //     setIsDarkMode(true);
  //     document.body.classList.add('dark-mode');
  //   }
  // }, []);

  // useEffect(() => {
  //   const skipIntroRoutes = ['/dashboard', '/login', '/loginform', '/solarsystem'];
  //   if (skipIntroRoutes.includes(location.pathname)) {
  //     setShowIntro(false);
  //   }
  // }, [location.pathname]);

  // const handleDarkModeToggle = (e) => {
  //   const isChecked = e.target.checked;
  //   setIsDarkMode(isChecked);
  //   document.body.classList.toggle('dark-mode', isChecked);
  //   localStorage.setItem('darkMode', isChecked.toString());
  // };

  return (
    <>
      <Routes>
        {/* <Route path="/" element={<Intro/>} />
        <Route path="/solarsystem" element={<SolarSystem />} /> */}

        <Route path="/" element={<SolarSystem/>} />
        <Route path="/solarsystem" element={<Navigate to="/" replace />} />
        <Route path="/xplorewithme" element={<XploreLanding />} />
        <Route path="/nasaspaceappchallenge" element={<NASASpaceApp/>} />
        <Route path="/sar" element={<SARObservatory/>} />

      </Routes>
    </>
  );
  
  // if (showIntro) {
  //   return <Intro />;
  // }

  // return (
  //   <div>
  //     {/* <Navbar /> */}
  //     <Routes>
  //       <Route path="/loginform" element={<LoginForm />} />
  //       <Route path="/dashboard" element={<Dashboard />} />
  //       <Route
  //         path="/SolarSystem"
  //         element={isLoggedIn ? <SolarSystem /> : <Dashboard />}
  //       />
  //     </Routes>
  //     <Footer />
  // </div>
  // );
}

export default App;
